import React, { useEffect, useState } from 'react';
import MasterPage from 'components/MasterPage'
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { DashboardOutlined } from '@material-ui/icons';
import { api } from 'services';
import { parseDateBR } from 'helpers/date';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

function FundByCompany(){
  const [ Funds, SetFunds ] = useState({list:[],load:false});
  const [ CompanySelected, SetCompanySelected ] = useState(undefined);
  const [ Companies, SetCompanies ] = useState([]);
  const [ FiscalYears, SetFiscalYears ] = useState([]);
  const [ FiscalYearSelected, SetFiscalYearSelected ] = useState(undefined);

  const { t } = useTranslation();

  useEffect(() => {
    api.get("companies/for-select").then(({data})=>{
      SetCompanies(data);
    })
  },[]);

  useEffect(()=>{
    SetFunds({list:[],load:true});
    if(CompanySelected && FiscalYearSelected){
      api.get("report-funds-by-company/"+CompanySelected,{params:{
        fiscal_year:FiscalYearSelected
      }}).then(({data})=>{
        SetFunds({list:data,load:false});
      });
    } else {
      SetFunds({list:[],load:false});
    }
  },[CompanySelected, FiscalYearSelected]);

  useEffect(()=>{
    SetFiscalYears([]);
    if(CompanySelected){
      api.get("report-fybc/"+CompanySelected).then(({data})=>{
        SetFiscalYears(data);
        if(data.length > 0){
          SetFiscalYearSelected(data[0]);
        } else {
          SetFiscalYearSelected(undefined);
        }
      });
    }
  },[CompanySelected]);

  function renderList(list = []){
    if(list.length === 0){
      return (
        <tr>
          <td colSpan="7">Sem dados para mostrar</td>
        </tr>
      );
    }
    return (
      list.map((item,key)=>{
        return(
          <tr key={key} style={{textAlign: 'center'}}>
            <td>{item.id}</td>
            <td>{item.type.name}</td>
            <td>{`${item.company_rule.period.type.name} ${item.company_rule.period.position}`}</td>
            <td>{item.fiscal_year}</td>
            <td>{parseDateBR(item.created_at)}</td>
            <td>{parseFloat(item.value_real).toLocaleString("pt-br",{style:"currency",currency:"BRL"})}</td>
            <td>{item.histories[0].user.fullname}</td>
          </tr>
        );
      })
    );
  }

  return (
    <Card.Body className="shadow bg-white rounded mb-3">
      <Row>
        <Col className="d-flex mt-3 mb-3">
          <DashboardOutlined className="icon-title" />
          <h4 className="title-dashboard mt-2">Relatório de Verbas por Fabricante</h4>
        </Col>
        <Col md="12" className="mb-2">
          {/* <Button
            onClick={() => exportData()}
            disabled={isExport}
          >
            Exportar Tabela
            {' '}
            <Spinner
              animation="border"
              role="status"
              size="sm"
              style={!isExport ? { display: 'none' } : {}}
            />
          </Button> */}
        </Col>
      </Row>
      <Row>
        <Col xs="4">
          <Form.Group>
            <Form.Label>{t('label:company')}</Form.Label>
            <Select
              mode="input"
              options={Companies}
              placeholder={t('label:select')}
              isDisabled={Companies.length===0}
              isLoading={Companies.length===0}
              onChange={(e) => {
                SetCompanySelected(e.value);
              }}
            />
          </Form.Group>
        </Col>
        <Col xs="auto">
          <Form.Group>
            <Form.Label>Ano fiscal</Form.Label>
            <Form.Control
              as="select"
              value={FiscalYearSelected}
              onChange={(e)=>{
                SetFiscalYearSelected(e.target.value);
              }}
            >
              <option value={undefined}>Selecione</option>
              {FiscalYears.map((item,key)=>{
                return <option key={key} value={item}>{item}</option>
              })}
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <Col>
              <table className="table" style={{textAlign: 'center'}}>
                <thead>
                  <tr>
                    <th>ID Inf</th>
                    <th>Tipo</th>
                    <th>Período</th>
                    <th>Ano Fiscal</th>
                    <th>Data Inc</th>
                    <th>Valor Real</th>
                    <th>Analista</th>
                  </tr>
                </thead>
                <tbody>
                  {Funds.load?(
                    <tr><td colSpan="7">
                      <Spinner
                        animation="border"
                        role="status"
                        size="sm"
                      />
                    </td></tr>
                  ):renderList(Funds.list)}
                </tbody>
              </table>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card.Body>
  );
}

export default MasterPage(FundByCompany)